import type { ModuleFile } from '../../core/modules.ts';

// Módulo «style»: manifiesto. Las pantallas se cargan de forma perezosa.
export const manifests: ModuleFile['manifests'] = [
  {
    id: 'style',
    title: 'Estilo y reglas',
    path: 'estilo',
    nav: { group: 'Canal', label: 'Estilo y reglas', icon: '✎', order: 2 },
    load: () => import('./StylePage.tsx').then((m) => ({ default: m.StylePage })),
  },
];
